import { useEffect, useState } from "react";
import { useAppDispatch, resetPassword } from "../../store";
import { useApi } from "../../api";
import { ReCaptcha, InputFormElement, SubmitFormElement } from "../general";
import { ErrorWrapper } from "../wrappers";
import { DEFAULT_ERROR_WITH_SUGGESTION_MESSAGE } from "../../ui/constants";

export const ResetPasswordForm = () => {
  const [email, setEmail] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [recaptchaToken, setRecaptchaToken] = useState("");

  const dispatch = useAppDispatch();
  const { getAnonymousApi } = useApi();

  useEffect(() => {
    if (!!recaptchaToken) setErrorMessage("");
  }, [recaptchaToken]);

  const handleResetPassword = async (email: string, recaptchaToken: string) => {
    const api = await getAnonymousApi();
    const value = { email, recaptchaToken };
    const resetResult = await dispatch(resetPassword({ api, value }));
    if ("error" in resetResult) {
      setErrorMessage(DEFAULT_ERROR_WITH_SUGGESTION_MESSAGE);
    } else {
      setSuccessMessage(
        `If ${email}  is a valid customer email address, the reset instructions will be sent to it in a while. Please also check your spam folder.`,
      );
      setErrorMessage("");
    }
  };

  return (
    <ErrorWrapper errorMessage={errorMessage}>
      {successMessage ? (
        <div className="font-medium text-stone-700 dark:text-stone-300">
          {successMessage}
        </div>
      ) : !recaptchaToken ? (
        <ReCaptcha
          errorMessage={errorMessage}
          setRecaptchaToken={setRecaptchaToken}
          actionName="password_reset"
          setErrorMessage={setErrorMessage}
        />
      ) : (
        <form
          onSubmit={(event) => {
            event.preventDefault();
            handleResetPassword(email, recaptchaToken);
          }}
        >
          <>
            <InputFormElement
              value={email}
              setValue={(value) => setEmail(value.toString())}
              currentStep={{
                name: "email",
                title: "Email address",
                type: "email",
                required: true,
              }}
            />

            <SubmitFormElement submitTitle="Reset password" disabled={false} />
          </>
        </form>
      )}
    </ErrorWrapper>
  );
};
